/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

const { number, string } = PropTypes;
export const InsightPropType = PropTypes.shape({
  insightId: number.isRequired,
  insightName: string.isRequired,
  insightStatus: string.isRequired,
});
